import Vue from 'vue'
import Vuex from 'vuex'
import { fb_auth, fb_users, fb_db } from '../firebase'
import bumpers from '@/assets/AdminNo.js';

Vue.use(Vuex)

// handle page reload
fb_auth.onAuthStateChanged(user => {
  if (user) {
    store.commit('setCurrentUser', user)
    store.dispatch('fetchUserProfile')

    fb_users.doc(user.uid).onSnapshot(doc => {
      store.commit('setUserProfile', doc.data())
    })
  }
})

const store = new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    uic_admins: [],
    puic_admins: [],
  },
  actions: {
    fetchUserProfile({commit,state}) {
      fb_users.doc(state.currentUser.uid).get().then(res => {
        commit('setUserProfile', res.data())
      }).catch(err => {
        console.log(err)
      })
    },
    clearData({ commit }) {
      commit('setCurrentUser', null)
      commit('setUserProfile', {})
    },
    updateProfile({commit, state}, data) {
      fb_users.doc(state.currentUser.uid).update({
        firstanme: data.firstname,
        lastname: data.lastname,
        uic: data.uic,
      }).then(user => {
        //user updated, return user
      }).catch(err => {
        console.log(err)
      })
    },
    async getAdmins({state, commit}) {
      let uic_admins = [];
      let puic_admins = [];
      let userAuth = await fb_auth.currentUser
      let userData = await fb_users.doc(userAuth.uid).get()
      let user = userData.data()
      let UICs = []
      
      let uicData = await fb_db.collection('uics').where('puic','==',user.puic).get()
      uicData.forEach(u => {
        UICs.push(u.id)
      });
      console.log('filtered UICs by common PUIC',UICs)

        // comment this out when admins are in db
        bumpers.forEach(b => {
          if (UICs.includes(b.UIC)) {
            puic_admins.push(b)
          }
          if (b.UIC == user.uic) {
            uic_admins.push(b)
          }
        });

        // use this code after you have admins back in the db

        // const adminRef = fb_db.collection('admin');
        // const snapshot = await adminRef.where('uic', '==', user_uic).get();
        // if (snapshot.empty) {
        //   console.log('No matching documents.');
        //   return;
        // }  

        // snapshot.forEach(doc => {
        //   let item = doc.data();
        //   item.id = doc.id;
        //   returnData.push(item);
        // });

      commit('setPUIC_Admins', puic_admins)
      commit('setUIC_Admins', uic_admins)
    }
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val
    },
    setUserProfile(state, val) {
      state.userProfile = val
    },
    setPUIC_Admins(state, val) {
      state.puic_admins = val
    },
    setUIC_Admins(state, val) {
      state.uic_admins = val
    },
  }
})

export default store